import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import { useOtpAnalytics } from "../hooks/use-otp-logs";

interface OtpChannelChartProps {
  startDate?: string;
  endDate?: string;
}

const COLORS = ["#3b82f6", "#10b981", "#f59e0b"];

export function OtpChannelChart({
  startDate,
  endDate,
}: OtpChannelChartProps) {
  const { data: analytics, isLoading } = useOtpAnalytics({ startDate, endDate });

  if (isLoading || !analytics) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Channel Breakdown</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-80 animate-pulse bg-gray-100 rounded"></div>
        </CardContent>
      </Card>
    );
  }

  const chartData = [
    // { name: "SMS", value: analytics.channelBreakdown.SMS },
    { name: "Email", value: analytics.channelBreakdown.EMAIL },
    { name: "WhatsApp", value: analytics.channelBreakdown.WHATSAPP },
  ].filter((item) => item.value > 0);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Channel Breakdown</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={320}>
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percent }) =>
                `${name}: ${((percent || 0) * 100).toFixed(0)}%`
              }
              outerRadius={100}
              fill="#8884d8"
              dataKey="value"
            >
              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}

